import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import {
  AppBarIcon,
  AppBarLink,
  AppBarLinkLabel,
  AppBarLinkWrapper
} from 'components/AppBar';

const buildAppBarFulfillmentMethodOptionLink = (
  fulfillmentOptionIcon,
  fulfillmentOptionLabel,
  iconDisplayMd,
  isActive,
  iconInFrontOfLabel
) => {
  const linkIcon = (
    <Box
      display={{ xs: 'flex', md: iconDisplayMd }}
      margin={`0 ${iconInFrontOfLabel ? '8px' : '0'} 0 4px`}
    >
      <AppBarIcon icon={fulfillmentOptionIcon} />
    </Box>
  );

  const linkComponents = [
    <AppBarLink
      highlighted={isActive}
      key={`app-bar-link-${fulfillmentOptionLabel}`}
    >
      <AppBarLinkLabel bold dark highlighted={isActive}>
        {fulfillmentOptionLabel}
      </AppBarLinkLabel>
    </AppBarLink>
  ];

  if (iconInFrontOfLabel) {
    linkComponents.unshift(linkIcon);
  } else {
    linkComponents.push(linkIcon);
  }

  return linkComponents;
};

function AppBarFulfillmentMethodOptionLink({
  id,
  dataTestId,
  fulfillmentOptionIcon,
  fulfillmentOptionLabel,
  isActive,
  onClick,
  iconDisplayMd = 'none',
  iconInFrontOfLabel = false,
  shouldDisableFulfillmentOptions = false
}) {
  return (
    <AppBarLinkWrapper
      dataTestId={dataTestId}
      isHiddenOnMobile={!isActive}
      onClick={onClick}
      shouldDisableFulfillmentOptions={shouldDisableFulfillmentOptions}
      id={id}
    >
      {buildAppBarFulfillmentMethodOptionLink(
        fulfillmentOptionIcon,
        fulfillmentOptionLabel,
        iconDisplayMd,
        isActive,
        iconInFrontOfLabel
      )}
    </AppBarLinkWrapper>
  );
}

AppBarFulfillmentMethodOptionLink.propTypes = {
  id: PropTypes.string,
  dataTestId: PropTypes.string.isRequired,
  fulfillmentOptionIcon: PropTypes.string.isRequired,
  fulfillmentOptionLabel: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  iconDisplayMd: PropTypes.string,
  iconInFrontOfLabel: PropTypes.bool,
  shouldDisableFulfillmentOptions: PropTypes.bool
};

AppBarFulfillmentMethodOptionLink.defaultProps = {
  onClick: () => {}
};

export default AppBarFulfillmentMethodOptionLink;
